import * as React from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import "./accordions.sass";

export default function FluidAccordion(props) {
  return (
    <Accordion className="acc">
      {props.elements.map((element) => (
        <Card className="accBody">
          <Card.Header className="accHeader">
            <Accordion.Toggle as={Button} variant="link" eventKey={element}>
              {element.title}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey={element}>
            <Card.Body>{element.body}</Card.Body>
          </Accordion.Collapse>
        </Card>
      ))}
    </Accordion>
  );
}
